import { render } from "./ReceiptScan.vue?vue&type=template&id=42174399&scoped=true"
import script from "./ReceiptScan.vue?vue&type=script&lang=js"
export * from "./ReceiptScan.vue?vue&type=script&lang=js"

import "./ReceiptScan.vue?vue&type=style&index=0&id=42174399&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42174399"]])

export default __exports__